import { TreeviewHelper } from "src/app/modules/treeview-helpers";


export interface TreeviewSelection {
  checkedItems: TreeviewItem[];
  uncheckedItems: TreeviewItem[];
}

export interface TreeItem {
  text: string;
  value: any;
  disabled?: boolean;
  checked?: boolean;
  collapsed?: boolean;
  children?: TreeItem[];
  type?: TreeviewItemTypeEnum;
  projetId?: number;
  identifiant?: string;

}

export enum TreeviewItemTypeEnum {
  Projet,
  Tir,
  TirRealise,
  Aucun
}

export class TreeviewItem {
  private internalDisabled = false;
  private internalChecked = true;
  private internalCollapsed = false;
  private internalChildren: TreeviewItem[];
  text: string;
  value: any;
  type: TreeviewItemTypeEnum;
  projetId: number;
  identifiant: string;
  blasted: boolean;
  constructor(item: TreeItem, autoCorrectChecked = false, blasted = false) {
    if (item === null || item === undefined) {
      throw new Error('Item must be defined');
    }
    if (typeof item.text === 'string') {
      this.text = item.text;
    } else {
      throw new Error('A text of item must be string object');
    }
    this.blasted = blasted;
    this.value = item.value;
    this.type = item.type ?? TreeviewItemTypeEnum.Aucun;
    this.projetId = item.projetId;
    this.identifiant = item.identifiant ?? '';
    if (typeof item.checked === 'boolean') {
      this.checked = item.checked;
    }
    if (typeof item.collapsed === 'boolean') {
      this.collapsed = item.collapsed;
    }
    if (typeof item.disabled === 'boolean') {
      this.disabled = item.disabled;
    }
    if (item.children !== null && item.children !== undefined && item.children.length > 0) {
      this.children = item.children.map(child => {
        if (this.disabled === true) {
          child.disabled = true;
        }

        return new TreeviewItem(child);
      });
    }

    if (autoCorrectChecked) {
      this.correctChecked();
    }
  }

  get checked(): boolean {
    return this.internalChecked;
  }

  set checked(value: boolean) {
    if (!this.internalDisabled) {
      if (this.internalChecked !== value) {
        this.internalChecked = value;
      }
    }
  }

  get indeterminate(): boolean {
    return this.checked === undefined;
  }

  setCheckedRecursive(value: boolean): void {
    if (!this.internalDisabled) {
      this.internalChecked = value;
      if (this.internalChildren !== null && this.internalChildren !== undefined) {
        this.internalChildren.forEach(child => child.setCheckedRecursive(value));
      }
    }
  }

  get disabled(): boolean {
    return this.internalDisabled;
  }

  set disabled(value: boolean) {
    if (this.internalDisabled !== value) {
      this.internalDisabled = value;
      if (this.internalChildren !== null && this.internalChildren !== undefined) {
        this.internalChildren.forEach(child => child.disabled = value);
      }
    }
  }

  get collapsed(): boolean {
    return this.internalCollapsed;
  }

  set collapsed(value: boolean) {
    if (this.internalCollapsed !== value) {
      this.internalCollapsed = value;
    }
  }

  setCollapsedRecursive(value: boolean): void {
    this.internalCollapsed = value;
    if (this.internalChildren !== null && this.internalChildren !== undefined) {
      this.internalChildren.forEach(child => child.setCollapsedRecursive(value));
    }
  }

  get children(): TreeviewItem[] {
    return this.internalChildren;
  }

  set children(value: TreeviewItem[]) {
    if (this.internalChildren !== value) {
      if (value !== null && value !== undefined && value.length === 0) {
        throw new Error('Children must be not an empty array');
      }
      this.internalChildren = value;
      if (this.internalChildren !== null && this.internalChildren !== undefined) {
        let checked = null;
        this.internalChildren.forEach(child => {
          if (checked === null) {
            checked = child.checked;
          } else {
            if (child.checked !== checked) {
              checked = undefined;
              return;
            }
          }
        });
        this.internalChecked = checked;
      }
    }
  }

  getSelection(): TreeviewSelection {
    let checkedItems: TreeviewItem[] = [];
    let uncheckedItems: TreeviewItem[] = [];
    if (this.internalChildren == null || this.internalChildren === undefined) {
      if (this.internalChecked) {
        checkedItems.push(this);
      } else {
        uncheckedItems.push(this);
      }
    } else {
      const selection = TreeviewHelper.concatSelection(this.internalChildren, checkedItems, uncheckedItems);
      checkedItems = selection.checked;
      uncheckedItems = selection.unchecked;
    }

    return {
      checkedItems,
      uncheckedItems
    };
  }

  correctChecked(): void {
    this.internalChecked = this.getCorrectChecked();
  }

  private getCorrectChecked(): boolean {
    let checked: boolean = null;
    if (this.internalChildren !== null && this.internalChildren !== undefined) {
      for (const child of this.internalChildren) {
        child.internalChecked = child.getCorrectChecked();
        if (checked === null) {
          checked = child.internalChecked;
        } else if (checked !== child.internalChecked) {
          checked = undefined;
          break;
        }
      }
    } else {
      checked = this.checked;
    }

    return checked;
  }
}
